// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userModal__QEHTq {
  width: 725px;
  height: 715px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.userModal__QEHTq.customUnits__i_KxI {
  height: 870px;
}
@media (max-width: 850px) {
  .userModal__QEHTq {
    width: 100%;
    height: 98%;
    max-width: 595px;
  }
}

.modalBody__CIdUu {
  flex: 1;
  padding: 25px 25px 0;
}

.modalBodyUser__H9I6Z {
  max-height: 80px;
  margin-bottom: 25px;
}
@media (max-width: 850px) {
  .modalBodyUser__H9I6Z {
    margin-bottom: 15px;
  }
}

.modalFooter__vKnpL {
  padding: 25px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btnBlock__sR7_O {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}

.deleteBtn__ZXQ2m {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  color: var(--labels-filled-surface-critical);
  cursor: pointer;
}

.gifCenter__BORF9 {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.userStepsDeleteBtn__b9U_W {
  line-height: 12px;
  color: var(--labels-filled-surface-critical);
  cursor: pointer;
}

.subtitleText__qqSBi {
  font-size: 18px;
  line-height: 20px;
}

.skeletonUserInfoWrapper__icL0a {
  display: flex;
  align-items: center;
  gap: 25px;
}

.skeletonUserInfo__iQJ8J {
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.skeletonUserInfoImage__oGBfZ {
  border-radius: 50%;
  width: 80px;
  height: 80px;
}

.skeletonUserInfoName__uJf37,
.skeletonUserStatusBlock__oEUmn {
  height: 20px;
}

.skeletonUserInfoName__uJf37 {
  width: 70%;
}

.skeletonUserStatusBlock__oEUmn {
  width: 30%;
}

.skeletonUserInfoNameWrapper__L1s5R {
  display: flex;
  gap: 10px;
}

.skeletonField__bVkov {
  height: 35px;
}

.skeletonFieldsWrapper__IfVfZ {
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  gap: 22px 32px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/UserModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;AA2EE;EACE,aAAA;AAzEJ;AA4EE;EAXF;IAYI,WAAA;IACA,WAAA;IACA,gBAAA;EAzEF;AACF;;AA4EA;EACE,OAAA;EACA,oBAAA;AAzEF;;AA4EA;EACE,gBAAA;EACA,mBAAA;AAzEF;AA2EE;EAJF;IAKI,mBAAA;EAxEF;AACF;;AA2EA;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,4CAAA;EACA,eAAA;AAxEF;;AA2EA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,iBAAA;EACA,4CAAA;EACA,eAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,iBAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAxEF;;AA2EA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAxEF;;AA2EA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAxEF;;AA2EA;;EAEE,YAAA;AAxEF;;AA2EA;EACE,UAAA;AAxEF;;AA2EA;EACE,UAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,SAAA;AAxEF;;AA2EA;EACE,YAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.userModal {\n  width: 725px;\n  height: 715px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  &.customUnits {\n    height: 870px;\n  }\n\n  @media (max-width: 850px) {\n    width: 100%;\n    height: 98%;\n    max-width: 595px;\n  }\n}\n\n.modalBody {\n  flex: 1;\n  padding: 25px 25px 0;\n}\n\n.modalBodyUser {\n  max-height: 80px;\n  margin-bottom: 25px;\n\n  @media (max-width: 850px) {\n    margin-bottom: 15px;\n  }\n}\n\n.modalFooter {\n  padding: 25px 25px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.btnBlock {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 25px;\n}\n\n.deleteBtn {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--labels-filled-surface-critical);\n  cursor: pointer;\n}\n\n.gifCenter {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.userStepsDeleteBtn {\n  line-height: 12px;\n  color: var(--labels-filled-surface-critical);\n  cursor: pointer;\n}\n\n.subtitleText {\n  font-size: 18px;\n  line-height: 20px;\n}\n\n.skeletonUserInfoWrapper {\n  display: flex;\n  align-items: center;\n  gap: 25px;\n}\n\n.skeletonUserInfo {\n  width: 30%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.skeletonUserInfoImage {\n  border-radius: 50%;\n  width: 80px;\n  height: 80px;\n}\n\n.skeletonUserInfoName,\n.skeletonUserStatusBlock {\n  height: 20px;\n}\n\n.skeletonUserInfoName {\n  width: 70%;\n}\n\n.skeletonUserStatusBlock {\n  width: 30%;\n}\n\n.skeletonUserInfoNameWrapper {\n  display: flex;\n  gap: 10px;\n}\n\n.skeletonField {\n  height: 35px;\n}\n\n.skeletonFieldsWrapper {\n  display: grid;\n  align-items: center;\n  grid-template-columns: 1fr 1fr;\n  gap: 22px 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userModal": `userModal__QEHTq`,
	"customUnits": `customUnits__i_KxI`,
	"modalBody": `modalBody__CIdUu`,
	"modalBodyUser": `modalBodyUser__H9I6Z`,
	"modalFooter": `modalFooter__vKnpL`,
	"btnBlock": `btnBlock__sR7_O`,
	"deleteBtn": `deleteBtn__ZXQ2m`,
	"gifCenter": `gifCenter__BORF9`,
	"userStepsDeleteBtn": `userStepsDeleteBtn__b9U_W`,
	"subtitleText": `subtitleText__qqSBi`,
	"skeletonUserInfoWrapper": `skeletonUserInfoWrapper__icL0a`,
	"skeletonUserInfo": `skeletonUserInfo__iQJ8J`,
	"skeletonUserInfoImage": `skeletonUserInfoImage__oGBfZ`,
	"skeletonUserInfoName": `skeletonUserInfoName__uJf37`,
	"skeletonUserStatusBlock": `skeletonUserStatusBlock__oEUmn`,
	"skeletonUserInfoNameWrapper": `skeletonUserInfoNameWrapper__L1s5R`,
	"skeletonField": `skeletonField__bVkov`,
	"skeletonFieldsWrapper": `skeletonFieldsWrapper__IfVfZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
